import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const DeliveryExpress = createSvgIcon(
  <>
    <path d="M2.25 4.5h9v12H9.182A3.372 3.372 0 0 0 6.375 15c-1.17 0-2.201.596-2.807 1.5H1.5v2.25h1.52a3.376 3.376 0 0 0 6.71 0h4.54a3.376 3.376 0 0 0 6.71 0H24v-6.662c0-.71-.401-1.359-1.037-1.677l-3.622-1.81-.838-3.351H13.5v-3H2.25V4.5Zm18.182 12a3.372 3.372 0 0 0-2.807-1.5c-1.17 0-2.201.596-2.807 1.5H13.5v-9h3.247l.662 2.65 4.341 2.17v4.18h-1.318Z" />
    <path d="M0 6.75h7.5V9H0V6.75Zm9 3.75H2.25v2.25H9V10.5Z" />
  </>,
  'DeliveryExpress'
);

export { DeliveryExpress };